export const MY_ACCOUNT = 'myaccount';
export const ORDER_HISTORY = 'order-history';
export const MEAL_PLAN = `${MY_ACCOUNT}/mealplan`;
export const CHECKOUT = 'checkout';
export const PASSWORD = "password";
export const RESET_PASSWORD = PASSWORD+"/reset/:resetToken";



// WEBPACK FOOTER //
// ./src/util/avialableRoutes.js